// extracted by mini-css-extract-plugin
export default {"main":"isbQz_JS3AD79DNWrtuO","chatContainer":"g1_o3VNw6SP3bmWkbP_i","chat":"A02AA7BE5LGr4ucWIarx","mdMessage":"KGB3_EWUFGxATJpGxdV0"};